import React from 'react'
import { createRoot } from 'react-dom/client'
import { ApolloProvider } from '@apollo/client'
import { RouterProvider } from 'react-router-dom'
import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v6'
import client from 'apollo/client'
import PageNotFound from 'pages/PageNotFound'
import { LDProvider } from 'launchdarkly-react-client-sdk'
import { HelmetProvider } from 'react-helmet-async'
import config from 'constants/config'
import { unregister } from './registerServiceWorker'
import App from './App'
import init from './init'
import './index.css'
import './assets/css/fonts.css'
import 'antd/dist/reset.css'

const router = createBrowserRouter([
  {
    path: '/*',
    element: <App />,
    errorElement: <PageNotFound />
  }
])

const Index = () => (
  <HelmetProvider>
    <LDProvider
      clientSideID={config?.LAUNCH_DARKLY_CLIENT_ID}
      reactOptions={{ sendEventsOnFlagRead: false }}
      options={{ fetchGoals: false }}
    >
      <ApolloProvider client={client}>
        <RouterProvider router={router} />
      </ApolloProvider>
    </LDProvider>
  </HelmetProvider>
)

function renderApp() {
  const root = createRoot(document.getElementById('root'))

  root.render(<Index />)
}

init()

// Hot Module Replacement
// On first pass, render whole application as usual

renderApp()

// However, if we support HMR

if (module.hot) {
  // Start accepting App.js changes
  module.hot.accept('./App.js', () => {
    // When App.js or any subsequent imports changes
    // We just ask React to drop the old tree and render a new one
    // (possibly, keeping states between changes)
    renderApp()
  })
}

// If anyone wishes to implement HMR support deeper down the React tree
// They must do the same thing:
// 1. Choose file/component you wish to reload
// 2. Implement custom logic that will swap old code to new code
// 3. Use module.hot.accept to run custom swapping logic on code change

unregister()
